export enum AnalyticsExportFormat {
  Xlsx = 'XLSX',
  Pdf = 'PDF',
}
